const handleUseSeoMeta = seo_obj => {
  return {
    ...seo_obj,
    ...(seo_obj.description && {
      'og:description': seo_obj.description,
      'twitter:description': seo_obj.description,
    }),
    ...(seo_obj.image && {
      'og:image': seo_obj.image,
      'twitter:image': seo_obj.image,
    }),
  };
};

export default handleUseSeoMeta;
